"use client";

import Image from "next/image";
import plur from "plur";

import SignUpButtonWrapper from "@/app/(discover)/components/sign-up-button-wrapper";
import gatedResultsAvatars from "@/components/shared/auth-paywall/assets/connect-gated-results-avatars.png";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

type ResultsPreviewSignUpCardProps = {
  remainingCount: number;
  className?: string;
};

const DEFAULT_ITEM_LABEL = "school";
const TITLE_NUMBER_FORMATTER = new Intl.NumberFormat("en-US");
const AVATAR_IMAGE_WIDTH = 208;
const AVATAR_IMAGE_HEIGHT = 48;
const DESCRIPTION =
  "Skip the tedious applications and connect directly with principals who are hiring in your area";

const getPreviewTitle = (count: number) => {
  if (count <= 0) {
    return "Get started to view more schools that match your criteria";
  }

  return `Get started to view ${TITLE_NUMBER_FORMATTER.format(
    count,
  )} more ${plur(DEFAULT_ITEM_LABEL, count)} that match your criteria`;
};

export default function ResultsPreviewSignUpCard({
  remainingCount,
  className,
}: ResultsPreviewSignUpCardProps) {
  return (
    <Card
      className={cn("border bg-background/95 shadow-sm text-center", className)}
    >
      <CardContent className="px-6 py-8 space-y-4">
        <div className="flex justify-center">
          <Image
            src={gatedResultsAvatars}
            alt="Educator profiles"
            className="h-12 w-auto"
            width={AVATAR_IMAGE_WIDTH}
            height={AVATAR_IMAGE_HEIGHT}
            loading="lazy"
            decoding="async"
            quality={100}
          />
        </div>
        <div className="space-y-2">
          <h3 className="text-lg font-semibold text-foreground">
            {getPreviewTitle(remainingCount)}
          </h3>
          <p className="text-sm text-muted-foreground">{DESCRIPTION}</p>
        </div>
        <div className="flex justify-center">
          <SignUpButtonWrapper
            variant="default"
            className="h-10 px-6"
            label="Create free profile"
          />
        </div>
      </CardContent>
    </Card>
  );
}
